<div class="container" *ngIf="cartProducts.data.length > 0">
  <div *ngIf="cartProducts.data[0].numInCart === 0;" class="text-center my-5">
    <h4>{{'CHECKOUT.CARTEMPTY' | translate}}</h4>
    <button class="btn btn-primary btn-lg mt-3" routerLink="/home/product">{{'CHECKOUT.SHOP' | translate}}</button>
  </div>
  <div class="row" *ngIf="cartProducts.data[0].numInCart > 0">
    <!-- List of Products -->
    <div class="col-8">
      <div class="row">
        <div class="col-4" *ngFor="let c of cartProducts.data let i=index">
          <div class="item">
            <div class="mb-r">
              <!--Card-->
              <div class="card card-cascade wider">
                <!--Card image-->
                <!-- <a [routerLink]="['/products/product', product.$key]"> -->
                <div class="view overlay hm-white-slight">
                  <img [src]="c.product.image" class="img-fluid" alt="" width="360px" height="500px" />
                  <a>
                    <div class="mask waves-effect waves-light" mdbRippleRadius></div>
                  </a>
                </div>
                <!-- </a> -->

                <!--/.Card image-->

                <!--Card content-->
                <div class="card-body text-center no-padding">
                  <!--Category & Title-->
                  <!-- <a class="text-muted">
                      <h5>{{ c.product.productCategory }}</h5>
                    </a> -->
                  <h5 class="card-title">
                    <strong>
                      <!-- <a [routerLink]="['/products/product', product.$key]">{{ -->
                      {{
                          c.product.title
                        }}
                      <!-- </a> -->
                    </strong>
                  </h5>

                  <!--Description-->
                  <p class="card-text">{{'CART.QUANTITY' | translate}} 
                    <i class="value-button" id="decrease" (click)="ChangeQuantity(i, false)" class="fa fa-minus"></i>
                    {{c.numInCart }}
                    <i class="value-button" id="increase" (click)="ChangeQuantity(i, true)" class="fa fa-plus"></i>
                  </p>
                  <div class="value-button" id="decrease" (click)="ChangeQuantity(i, false)">

                  </div>
                  <div class="value-button" id="increase" (click)="ChangeQuantity(i, true)">

                  </div>

                  <p class="card-text">{{'CART.PRICEPERITEM' | translate}}
                    {{ c.product.price  | currency: ('CURRENCY.VALUE' | translate)}}</p>

                  <!--Card footer-->
                  <div class="card-footer">
                    <span>{{'CART.TOTALPRICE' | translate}}
                      {{ c.product.price * c.numInCart | currency: ('CURRENCY.VALUE' | translate)}}</span>
                    <p></p>
                    <span class="center">
                      <a class="space" placement="top" mdbTooltip="Quick Look" container="body"
                        routerLink="/home/product/productDetails/{{c.product.id}}">
                        <i class="fa fa-eye"></i>
                      </a>
                      <a class="delete" placement="top" mdbTooltip="Remove Product" container="body"
                        (click)="removeCartProduct(i)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <!--/.Card content-->
              </div>
              <!--/.Card-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <h4 class="d-flex  mb-3">
        <span class="text-muted">{{'CART.YOURCART' | translate}}</span>
        <!-- <span class="badge badge-primary badge-pill">{{ productsInCart }}</span> -->
      </h4>
      <ul class="list-group mb-3">
        <li class="list-group-item  justify-content-between" *ngFor="let c of cartProducts.data">
          <div class="row">
            <div class="col-9">
              <h6 class="my-0">{{ c.product.title }}</h6>
            </div>
            <div class="col-3">
            <span class="cart-value align-items-end"
              class="text-muted">{{ c.product.price * c.numInCart | currency: ('CURRENCY.VALUE' | translate) }}</span>
              </div>
          </div>
        </li>
        <hr />
        <li class="list-group-item  justify-content-between">
          <div class="row">
            <div class="col-9">
          <span>{{'CART.TOTAL' | translate}} </span>
          </div>
          <div class="col-3">
          <strong>{{ cartTotal | currency: ('CURRENCY.VALUE' | translate) }}</strong>
          </div>
          </div>
        </li>
        <a class="btn btn-primary" [routerLink]="['/home/product']">{{'CART.CONTINUESHOPPING' | translate}}</a>
        <a class="test-btn btn btn-success" id="checkout"
          [routerLink]="['/home/checkout']">{{'CART.CHECKOUT' | translate}}</a>
      </ul>
    </div>
  </div>
</div>
<!-- <div class="container" *ngIf="cartProducts.length === 0">
    <app-no-products-found
      [title]="messageTitle"
      [description]="messageDescription"
    ></app-no-products-found>
  </div> -->
